module.exports = __webpack_public_path__ + "static/media/ProximaNova-ThinIt.2b7c2fd0.eot";